var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNotificationTick = function SvgNotificationTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27 27"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#8bc52f",
    cx: 13.5,
    cy: 13.5,
    r: 11.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m11.13 20.01-5.81-5.8 2.12-2.12 3.69 3.68 8.43-8.43 2.12 2.12-10.55 10.55z"
  })));
};
export default SvgNotificationTick;